module.exports = __webpack_public_path__ + "static/img/2.f7660a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pczhongfu/2.png
// module id = u9y0
// module chunks = 0